const multimediaEvents = {
    STOP_ALL_PLAYBACK: 'MultimediaDisplay:stopAllMediaPlayback',
    START_PLAYING: 'MultimediaDisplay:startPlaying',
    MASTER_VOLUME_CHANGE: 'MultimediaDisplay:masterVolumeChange',
    MEDIA_PLAYED_TO_COMPLETION: 'MultimediaDisplay:mediaPlayedToCompletion',
};

export default multimediaEvents;
